import { makeLogger } from "@/shared/consola";
import { defineStore } from "pinia";

interface State {
    isPreview: boolean;
    isPageMode: boolean;
}

const STORE_NAME = "render-preview";
const logger = makeLogger("🍍" + STORE_NAME);

export const useRenderPreviewStore = defineStore(STORE_NAME, {
    state: (): State => ({
        isPreview: false,
        isPageMode: false,
    }),
    actions: {
        setIsPreview(isPreview: boolean) {
            this.isPreview = isPreview;
            logger.debug("setIsPreview", isPreview);
        },
        setIsPageMode(isPageMode: boolean) {
            this.isPageMode = isPageMode;
            logger.debug("setIsPageMode", isPageMode);
        },
    },
});
